import api from "./api";

const homeworkService = {
    // ── Homework (admin/teacher) ────────────────────────────────────────────
    getHomeworkList: (params) => api.get("/homework", { params }),
    getHomeworkById: (id) => api.get(`/homework/${id}`),
    createHomework: (data) => api.post("/homework", data),
    updateHomework: (id, data) => api.put(`/homework/${id}`, data),
    deleteHomework: (id) => api.delete(`/homework/${id}`),

    // ── Attachment upload ────────────────────────────────────────────────────
    // Expects a browser File object; posts multipart/form-data.
    uploadHomeworkAttachment: (file) => {
        const formData = new FormData();
        formData.append("file", file);
        return api.post("/homework/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },

    // ── Submissions (teacher grading side) ───────────────────────────────────
    getSubmissionsByHomework: (homeworkId) => api.get(`/homework/${homeworkId}/submissions`),
    getSubmissionDetail: (homeworkId, studentId) =>
        api.get(`/homework/${homeworkId}/submissions/${studentId}`),
    gradeSubmission: (submissionId, data) =>
        api.put(`/homework/submissions/${submissionId}/grade`, data),
};

export default homeworkService;